import {createSelector} from "reselect";
import {TRootState} from "types";
import {STProject} from "api/projectApi/types";
import {TProjectListReducerState} from "store/project-list/types";

export const projectTabIndexSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).projectTabIndex;

export const projectSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState)?.project;

export const currentProjectIDSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).currentProjectID;

export const projectPaginationSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).pagination;

export const projectsSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).projects;

export const latestProjectsSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).latestProjects;

export const createProjectModalSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).createProjectModal;
export const editProjectModalSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).editProjectModal;

export const duplicateProjectModalSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).duplicateProjectModal;
export const editProjectFormSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).projectForm;

export const updateProjectListInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).updateProjectListInProgress;

export const getProjectListInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).getProjectListInProgress;

export const getLatestProjectListInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).getLatestProjectListInProgress;

export const loadingProjectsSelector = createSelector(
	[updateProjectListInProgressSelector, getProjectListInProgressSelector],
	(updateProjectListInProgress, getProjectListInProgress) =>
		updateProjectListInProgress || getProjectListInProgress,
);

export const getProjectNameByProjectIDSelector = createSelector(
	[projectsSelector, (_, id) => id],
	(projectList, id) => projectList.find((project: STProject) => project.id === id)?.name || null,
);

export const updateProjectInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).updateProjectInProgress;

export const duplicateProjectInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).duplicateProjectInProgress;

export const saveProjectInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).saveProjectInProgress;

export const deletingProjectInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).deletingProjectInProgress;

export const getProjectInProgressSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).getProjectInProgress;

export const getProjectWorkflowStepSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).projectWorkflowStep;
export const getProjectFormSelector = (state: TRootState) =>
	(state.projectList as TProjectListReducerState).projectForm;
